export class JavaCompilerStringConstants {
    public static mainMethodIdentifier = "$main";
}